import { useMutation } from "react-query";
import { secureAxios } from "../../constant/auth";
import { getImageURL } from "../../utils/image";
import { queryClient } from "../query";

export const useUploadProfile = (userId, setProfile, profileImg) => {
  return useMutation((formData) => {
    return secureAxios
      .post(`/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return secureAxios.patch(`/users/${userId}`, {
          profile_image: res.data.id,
        });
      })
      .then((res) => {
        setProfile({
          imgId: res.data.profile_image,
          imgUrl: getImageURL(res.data.profile_image),
        });
        if (profileImg) {
          secureAxios.delete(`/files/${profileImg.imgId}`);
        }
      })
      .then((res) => res);
  });
};

// export const useUploadfile = (payload) => {
//   return useMutation((formData) => {
//     return (
//       secureAxios
//         .post(`/files`, formData, {
//           headers: { "Content-Type": "multipart/form-data" },
//         })
//         // .then((res) => {
//         //   return secureAxios.post(`items/billing_credit_invoice`, {
//         //     file_id: res.data.id,
//         //     ...payload,
//         //   });
//         // })
//         .then((res) => {
//           //("res upload------", res.data);
//           return res.data;
//         })
//     );
//   });
// };

export const useUploadfile = (payload) => {
  return useMutation((formData) => {
    return secureAxios
      .post(`users/files/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        queryClient.invalidateQueries(["users/"]);
        return res.data;
      });
  });
};

export const useUploadRecordfile = (payload) => {
  return useMutation((formData) => {
    return secureAxios
      .post(`users/files/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        //("uload image", res);
        return secureAxios.post(`users/`, {
          action: "postUserRecords",
          clinic_id: 1,
          frontend: "True",
          files_id: res?.data[0]?.url,
          files: [res.data],
          ...payload,
        });
      })
      .then((res) => {
        queryClient.invalidateQueries(["users/"]);
        //("res upload------", res.data);
      });
  });
};
